// Import React for creating the Footer component
import React from "react";
// Import the CSS file for footer styling
import "../../css/Footer.css";
// Import SVG icons as React components
import { ReactComponent as PhoneIcon } from "../../assets/icons/contact_icons-01.svg";
import { ReactComponent as LocationIcon } from "../../assets/icons/contact_icons-02.svg";
// Import useNavigate hook for navigation
import { useNavigate } from "react-router-dom";

// Footer component displays contact info and legal notices
function Footer() {
  // Hook for programmatic navigation
  const navigate = useNavigate();
  return (
    <footer className="footer">
      {/* Contact Footer Section */}
      <div className="footer-contact-section">
        <div className="footer-contact-info">
          {/* Phone contact item */}
          <div className="footer-contact-item">
            <div className="footer-contact-icon">
              <PhoneIcon />
            </div>
            <div className="footer-contact-details">
              <a href="tel:02035046382" className="footer-contact-value">
                0203 504 6382
              </a>
            </div>
          </div>
          {/* Location contact item */}
          <div className="footer-contact-item">
            <div className="footer-contact-icon">
              <LocationIcon />
            </div>
            <div className="footer-contact-details">
              <span className="footer-contact-label footer-contact-value">
                6th Floor, 37 Lombard Street, London, EC3V 9BQ
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Legal Footer Section */}
      <div className="footer-legal">
        <h4>
          {/* Clickable privacy notice link */}
          <span
            onClick={() => navigate("/privacy-policy")}
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            Privacy Notice
          </span>
        </h4>
        {/* Regulatory and registration information */}
        <p>
          Portfolio Finance Ltd is an Appointed Representative of Rosemount
          Financial Solutions (IFA) Limited which is authorised and regulated by
          the Financial Conduct Authority.
        </p>
        <p>
          Rosemount Financial Solutions (IFA) Limited is entered on the
          Financial Services Register under reference 535515.
        </p>
        <p>
          Portfolio Finance Ltd is registered in England and Wales (Company
          Number: 16813072). Registered Address: 6th Floor, 37 Lombard Street,
          London, City of London, EC3V 9BQ.
        </p>
        <p style={{ color: "#fff" }}>
          <strong>
            The information on this website is subject to the UK regulatory
            regime and is intended for consumers in the UK.
          </strong>
        </p>
      </div>
    </footer>
  );
}

// Export the Footer component as default
export default Footer;
